export default function({ store, redirect, rootState, route }) {
    // If the user is not authenticated
    if (store.state.user.auth) {
        //console.log(route.path);
    }
}
